import { useState, useEffect } from "react";
import { ExportMetrics } from "../../../../types/niffler";
import { useSnackbar } from "../../../../components/Snackbar";
import { fetchExportsMetrics } from "../../../../apis/niffler/export";

interface UseExportMetricsResult {
  stats: ExportMetrics | null;
  loading: boolean;
  hasError: boolean;
  refetch: () => Promise<void>;
}

export function useExportMetrics(): UseExportMetricsResult {
  const { showError } = useSnackbar();
  const [stats, setStats] = useState<ExportMetrics | null>(null);
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const fetchStats = async () => {
    try {
      setLoading(true);
      setHasError(false);

      const response = await fetchExportsMetrics();

      setStats(response);
    } catch (err) {
      showError(
        err instanceof Error
          ? `Failed to fetch export metrics: ${err.message}`
          : "Failed to fetch export metrics"
      );
      setHasError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    stats,
    loading,
    hasError,
    refetch: fetchStats,
  };
}
